import styled, { keyframes } from "styled-components";

interface LoadingProps {
  size?: string;
}

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Overlay = styled.div<{ size?: string }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
  gap: 16px;
`;

const Spinner = styled.div<{ size?: string }>`
  animation: ${spin} 1s linear infinite;
  border-radius: 50%;
  height: ${({ size }) => (size ? size : "64")}px;
  width: ${({ size }) => (size ? size : "64")}px;
  border-left: 3px solid;
  border-bottom: 3px solid;
  border-color: #77ec84;
`;

export default function LoadingSpinner({ size }: LoadingProps) {
  return (
    <Overlay size={size}>
      <Spinner size={size} />
    </Overlay>
  );
}
